import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs'
import { map, catchError } from 'rxjs/operators'
import { TCCPHttpService } from '../../services/tccp-http.service';
import { TCCPConstantValues } from '../../models/tccp-constants';
import { TCCPLoggerService } from '../../services/tccp-logger.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {


  constructor(
    private httpService: TCCPHttpService, private logger: TCCPLoggerService) { }
  public appBase = TCCPConstantValues[environment.applicationName];
  public closeDriveConnect = new EventEmitter();
  /** For service call to get regions
   * @class DashboardService
   * @method getFeature
    * @returns Observable
   */
  getFeature(model: string, year: number, featureType: string): Observable<any> {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting flow', '');
    let url = this.appBase.Urls.FEATURE_URL + '?model=' + encodeURIComponent(model) + '&year=' + year + '&source=' +
      environment.applicationName;
    return this.httpService.get(url).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting flow failed', '', error);
          return error;
        })
    );
  }


}
